
import {Component, Vue, Prop} from 'vue-property-decorator';
import {appLocalStorage} from "../../../stores/checkout/services";

@Component({
  name: 'offer-summary',
  components: {
    CheckoutSummaryPersonalAddress: require('../summary/personal/address.vue').default,
  },
})
export default class extends Vue {
  @Prop({default: ''}) readonly value!: string;

  private updateNote(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.$emit('input', target.value)
  }

  private get customerEmail(): string {
    return this.$store.getters['CheckoutGlobal/customerEmail'] || '';
  }

  private get customerIsBusinessAccount(): string {
    return this.$store.getters['CheckoutGlobal/isBusinessAccount'] || '';
  }

  private get shippingAddress(): object {
    return this.$store.getters['CheckoutAddress/shippingAddress'];
  }

  private get billingAddress(): object {
    return this.$store.getters['CheckoutAddress/billingAddress'];
  }

  private get billingIsSameAsShipping(): boolean {
    return appLocalStorage.getItem('checkout-billing-is-same-as-shipping', true);
  }

  private get cartTotals(): object {
    return this.$store.getters['CheckoutTotals/cartTotals'];
  }

  private get totalsAvailable(): boolean {
    return this.$store.getters['CheckoutTotals/totalsAvailable'];
  }

  private get cartItems(): object {
    return this.$store.getters['CheckoutTotals/cartItems'];
  }

  private getPrice(priceKey): number {
    if (typeof this.cartTotals[priceKey] === 'undefined') {
      return 0; // Price not available
    }

    return this.cartTotals[priceKey];
  }

  private get getGrandTotalWithoutTax(): number
  {
    return this.getPrice('grand_total') - this.getPrice('tax_amount');
  }

  private gotoStep(step): void {
    this.$store.dispatch('CheckoutGlobal/gotoStep', step);
  }
}
